import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Main from './pages/Main';
import DraftList from './pages/Draft/DraftList';
import DraftView from './pages/Draft/DraftView';
import DraftRegist from './pages/Draft/DraftRegist';
import DraftModify from './pages/Draft/DraftModify';
import DraftCopy from './pages/Draft/DraftCopy';
import DraftTmpList from './pages/Draft/DraftTmpList';
import DraftTmpView from './pages/Draft/DraftTmpView';
import AlbaList from './pages/Alba/AlbaList';
import AdminList from './pages/Admin/AdminList';
import PrivateRoute from './components/Common/PrivateRoute';
import { useAuthStore } from './store/authStore';
import { authService } from './services/authService';
import './App.css';

const App: React.FC = () => {
  const { setUser, setLoading } = useAuthStore();

  // 앱 시작 시 세션 확인 (한 번만 실행)
  useEffect(() => {
    let isMounted = true;

    const checkSession = async () => {
      setLoading(true);
      try {
        const response = await authService.checkSession();
        if (isMounted && response.resultCode === 200 && response.data.user) {
          setUser(response.data.user);
        } else if (isMounted) {
          setUser(null);
        }
      } catch (error) {
        console.log('세션 없음 또는 만료됨');
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    checkSession();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 빈 배열로 한 번만 실행

  return (
    <BrowserRouter>
      <Routes>
        {/* 공개 라우트 */}
        <Route path="/login" element={<Login />} />

        {/* 보호된 라우트 */}
        <Route
          path="/main"
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        />

        {/* 관리자 라우트 */}
        <Route
          path="/admin/list"
          element={
            <PrivateRoute>
              <AdminList />
            </PrivateRoute>
          }
        />

        {/* 기안서 라우트 */}
        <Route
          path="/draft/list"
          element={
            <PrivateRoute>
              <DraftList />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/view/:idx"
          element={
            <PrivateRoute>
              <DraftView />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/regist"
          element={
            <PrivateRoute>
              <DraftRegist />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/modify/:idx"
          element={
            <PrivateRoute>
              <DraftModify />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/copy/:idx"
          element={
            <PrivateRoute>
              <DraftCopy />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/tmp-list"
          element={
            <PrivateRoute>
              <DraftTmpList />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft/tmp-view/:idx"
          element={
            <PrivateRoute>
              <DraftTmpView />
            </PrivateRoute>
          }
        />

        {/* 알바 라우트 */}
        <Route
          path="/alba/list"
          element={
            <PrivateRoute>
              <AlbaList />
            </PrivateRoute>
          }
        />

        {/* 기본 경로 - 로그인 페이지로 */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* 404 */}
        <Route path="*" element={<div>페이지를 찾을 수 없습니다.</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
// Force recompile
